<template>
  <div>
    <div
      v-if="
        filter.showType.toLowerCase() === 'list' && filter.children.length > 0
      "
    >
      <ul class="check-box-list">
        <li v-for="(filterItem, i) in filter.children" :key="i" class=" check-box-wrapper-tour">
          <input
            type="checkbox"
            :id="filterItem.id"
            :checked="filterItem.isSelected"
            v-model="filterItem.isSelected"
            class="check-box check-box--no-tik"
            @change="
              onChangeFilterItem(filterItem, filter.showType.toLowerCase())
            "
          />
          <label class="w-100" :for="filterItem.id">
            {{ filterItem.title }}
          </label>
        </li>
      </ul>
    </div>

    <div
      v-else-if="
        filter.showType.toLowerCase() === 'range' &&
          filter.type.toLowerCase() !== 'rate'
      "
    >
      <FilterItemRange :filter="filter" />
    </div>

    <div
      v-else-if="
        filter.showType.toLowerCase() === 'range' &&
          filter.type.toLowerCase() === 'rate'
      "
    >
      <ul class="check-box-list">
        <li class="check-box-wrapper check-box-wrapper-tour">
          
          <input 
            type="checkbox"
            :id="filter.id"
            :checked="filter.isSelected"
            v-model="filter.isSelected"
            class="check-box"
            @change="onChangeFilterItem(filter, filter.showType.toLowerCase())"
          />
        
          <label :for="filter.id" class="w-100">
            {{ filter.title }}
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import FilterItemRange from "./FilterItemRange";
import { mapActions } from "vuex";

export default {
  name: "FilterItem",

  props: ["filter"],

  components: {
    FilterItemRange,
  },

  data() {
    return {
      needMoreBtnFlag: false,
    };
  },

  computed: {
    moreBtnText() {
      if (this.needMoreBtnFlag) {
        return "بیشتر";
      }
      return "کمتر";
    },
  },

  methods: {
    ...mapActions({
      onChangeFilter: "onChangeFilter",
    }),

    onChangeFilterItem(filterItem) {
      this.onChangeFilter(filterItem);
    },

    needMoreBtn(length) {
      if (this.filter.children.length > 3) {
        this.needMoreBtnFlag = true;
      }
      return this.filter.children.length > 3;
    },

    toggleMoreBtn() {
      this.needMoreBtnFlag = !this.needMoreBtnFlag;
    },
  },

  created() {
    this.needMoreBtn(this.filter.children);
  },
};
</script>
